module.exports = __webpack_public_path__ + "static/media/image_two.c7d5ca01.jpg";